module.exports = __webpack_public_path__ + "03_mole.83cdbb09.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer2/03_mole.png
// module id = 0FAc
// module chunks = 0